// extracted by mini-css-extract-plugin
module.exports = {"icon":"AnimatedIcon_icon__16cv5","sprite":"AnimatedIcon_sprite__ZoyMF"};